// SPDX-License-Identifier: AGPL-3.0-or-later

import Theme from '@app/features/theme/state/Theme';
import * as UserSettingsCommands from '@app/features/user/commands/UserSettingsCommands';
import type {ThemeType} from '@app/vendor/constants/UserConstants';
import {ThemeTypes} from '@app/vendor/constants/UserConstants';

function applyLocalThemePreference(theme: ThemeType): void {
	Theme.setTheme(theme);
}

function persistThemePreference(theme: ThemeType): void {
	void UserSettingsCommands.update({theme});
}

function shouldSyncThemePreference(theme: ThemeType): boolean {
	return theme !== ThemeTypes.SYSTEM && Theme.syncAcrossDevices;
}

export function updateThemePreference(theme: ThemeType): void {
	if (theme === ThemeTypes.SYSTEM) {
		Theme.setSyncAcrossDevices(false);
		applyLocalThemePreference(theme);
		return;
	}
	if (shouldSyncThemePreference(theme)) {
		persistThemePreference(theme);
	} else {
		applyLocalThemePreference(theme);
	}
}

export function setSyncAcrossDevices(sync: boolean): void {
	Theme.setSyncAcrossDevices(sync);
}
